module.exports = "<!-- <h2 class=\"page-title\" *ngIf=\"loginService.isLogged\">Welcome!</h2> -->\n<dashboard-referrer *ngIf=\"isDashboardReferrerHomePage\"></dashboard-referrer>\n<app-dashboard-admin *ngIf=\"isDashboardHomePage\"></app-dashboard-admin>\n<app-projects *ngIf=\"isProjectsHomePage\"></app-projects>\n"


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/defaults/home/home.component.html
// module id = ../../../../../angular/app/components/defaults/home/home.component.html
// module chunks = 1